// extracted by mini-css-extract-plugin
module.exports = {"block":"ValuesUpdated_block__pLV8o","about":"ValuesUpdated_about__9n7_1","update":"ValuesUpdated_update__y5WYc"};